export async function getCurrentUser(context){
   try{
      
   }
   catch(e){
      throw e;
   }
}